import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para carga externa de atenciones de comensales
 */
export const cargaExternaApi = {
  /**
   * Procesa un archivo Excel con atenciones de comensales
   * @param {File} file - Archivo Excel
   * @param {number} homologacionId - ID de la homologación a usar
   * @param {number} idProyecto - ID del proyecto
   * @param {number} idComedor - ID del comedor
   * @param {number} idLector - ID del lector
   * @returns {Promise} - Respuesta de la API con estadísticas
   */
  procesarCargaExterna: (file, homologacionId, idProyecto, idComedor, idLector) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('homologacion_id', homologacionId);
    formData.append('id_proyecto', idProyecto);
    formData.append('id_comedor', idComedor);
    formData.append('id_lector', idLector);
    
    return pythonApiClient.post('/procesos/alimentacion/carga-externa', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
};

export default cargaExternaApi;
